import React from 'react';

const defaultContextValue = {
  ref: null
};

const AppContext = React.createContext(defaultContextValue);

export { AppContext };
